import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-point-right': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M428.8 137.6H342.6A115.5-115.5 0 0 1 344.8 115.2C344.8 67.3 309.7 32 252.8 32 207.5 32 195.8 80.5 177.1 110.8 169.4 123.2 160.1 134.1 151.2 144L151.1 144.2 151 144.3C135.7 161.8 127.8 168 120.8 168H118.1C112.4 163 104.6 160 96 160H32C14.3 160 0 172.9 0 188.8V419.2C0 435.1 14.3 448 32 448H96C104.6 448 112.4 445 118.1 440H120.8C149.5 440 187.9 480 248 480H269.3C331.8 480 368.1 441.3 369.2 388.9 381.7 371 387.7 348.1 385.2 326.1A93.1-93.1 0 0 1 393.2 304H428.8C474.2 304 512 266.4 512 220.8 512 175.7 473.9 137.6 428.8 137.6zM428.8 256H337.8C350.6 270.7 352.2 298.8 332.8 317.1 344.1 336.7 334.5 362.7 319.9 370.7 326.4 409.8 309.8 432 269.3 432H248C202.5 432 170.8 396.1 128 392.3V215.6C153.2 212.6 171 194.3 187.1 176 198.3 163.3 208.8 150.7 217.9 136.1 232.4 112.7 244 80 252.8 80 276.2 80 296.8 88.8 296.8 115.2 296.8 150.4 270.4 168.3 270.4 185.6H428.8C447.2 185.6 464 202.1 464 220.8 464 239.8 447.8 256 428.8 256zM88 384C88 397.3 77.3 408 64 408S40 397.3 40 384 50.7 360 64 360 88 370.7 88 384z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-point-right.js
// module id = TLsz
// module chunks = 144